import React from "react";
import { Typography, Banner } from "@bca/ui-library";

interface ErrorPlaceProxyBidProps {
  closeBanner: () => void;
}

const ErrorPlaceProxyBid: React.FunctionComponent<ErrorPlaceProxyBidProps> = ({
  closeBanner,
}) => {
  return (
    <Banner
      variant="warning"
      title="Service currently unavailable"
      primaryLinkLabel="Close"
      primaryLinkAction={closeBanner}
      paddingX={[20, 100, 20]}
      paddingY={20}
    >
      <Typography margin={0} variant="body" color="grey-blue">
        We're sorry, a problem occurred when placing your bid. Please try again.
      </Typography>
    </Banner>
  );
};

export default ErrorPlaceProxyBid;
